import { render, staticRenderFns } from "./Breaktest.vue?vue&type=template&id=18dc4195&scoped=true&"
import script from "./Breaktest.vue?vue&type=script&lang=js&"
export * from "./Breaktest.vue?vue&type=script&lang=js&"
import style0 from "./Breaktest.vue?vue&type=style&index=0&id=18dc4195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc4195",
  null
  
)

export default component.exports